import {DateFormat} from '../../date_format'
import KeyDownHandler from '../../key_down_handler'
import {preventDefault, isIE8, whichButtonPressed, cancelBubble, showElementAt} from '../../atBrowserUtils'
import $ from 'jquery'
import {Feature, isEnabled} from '../../features/index'
import messageResource from '../../messageResource'
import {KEY_CODE_ENTER, KEY_CODE_ESC} from '../../keyCodes'
import _ from 'underscore'
import TemplateView from "../../TemplateView";


export default class HireDateWarningDlg extends TemplateView {
    constructor($lightBoxEl, $scrollableLightboxContent, onConfirmCallback) {
        super($lightBoxEl)
        this.id = $lightBoxEl.attr('id')
        this.$lightBoxEl = $lightBoxEl;
        this.$scrollableLightboxContent = $scrollableLightboxContent;
        this.onConfirmCallback = onConfirmCallback;
        this.isIE8 = isIE8();
        this.$overlay = this._createOverlayIfNeededAndGet($lightBoxEl);
    }

    templateHtml() {
        return "<div id='<%=id%>_hireDateChangedWarningId'></div>";
    }

    _createOverlayIfNeededAndGet($element) {
        var $overlay = $element.find(".hireDateChangedOverlay");
        if ($overlay.length == 0) {
            $overlay = $("<div>").addClass("hireDateChangedOverlay");
            $overlay.css({"display": "none", "position": "absolute", "top": 0, "height": "100%"});
            $overlay.width($element.width());
            $element.append($overlay);
        }
        return $overlay;
    }

    close(isConfirmed) {
        this.onConfirmCallback(isConfirmed);
        this.hide();
    }

    showAt(selector, warningMsgKey, dateFrom, dateTo) {
        var self = this;
        KeyDownHandler.setOnKeyDownHandler(_.bind(this._keydownHandler, this));
        this.$overlay.css("display", "");

        this.$lightBoxEl.off();
        this.$lightBoxEl.on("wheel", function(event) {preventDefault(event)}); // modern standard
        this.$lightBoxEl.on("mousewheel", function(event) {preventDefault(event)}); // older browsers, IE
        this.$lightBoxEl.on("touchmove", function(event) {preventDefault(event)}); // mobile
        this.$lightBoxEl.on("mousedown", function(event) {return self._preventMouseMiddleButtonPress(event)});

        this._renderWarningContent(this.$el, warningMsgKey, dateFrom, dateTo);

        this.$el.focus();
        this.$el.show();
        showElementAt(this.$el, {of: selector, my: "left top", at: "left bottom", offset: "10px 10px "});

        this.$el.toggleClass('pointerAtTop', this.$el.offset().top > selector.offset().top)
        this.$el.toggleClass('pointerAtBottom', this.$el.offset().top < selector.offset().top)

        if (this.isIE8) {
            this.$scrollableLightboxContent.css("overflow-y", "hidden");
        }
    }

    hide() {
        KeyDownHandler.restoreOnKeyDownHandler();
        this.$overlay.css("display", "none");
        this.$lightBoxEl.off();
        this.$el.hide();

        if (this.isIE8) {
            this.$scrollableLightboxContent.css("overflow-y", "");
        }

    }

    _preventMouseMiddleButtonPress(event) {
        if (whichButtonPressed(event) == "middle") {
            this.preventDefault(event);
            return false;
        }
        return true;
    }

    _renderWarningContent(warningDiv, warningMsgKey, fromDate, toDate) {
        warningDiv.empty();

        var balancesChangedMsg = (isEnabled(Feature.PTO) && isEnabled(Feature.SDB)) ? messageResource.getMessage(
            "userlist.user_popup.hire_date_changed.balances") : "";

        warningDiv.append("<div class='warningMsgContainer'>" +
                          "<div class='msgContent'><span class='warningMsg'>" + messageResource.getMessage(warningMsgKey, [
                new DateFormat(window.SystemSettings.dateFormat).formatDate(fromDate),
                new DateFormat(window.SystemSettings.dateFormat).formatDate(toDate)
            ]).concat(balancesChangedMsg) +
                          "</span></div> </div>");
        var footer = $("<div class='warningFooter'></div>");
        var confirmBtn = $("<button class='hireDateConfirmBtn'>" + messageResource.getMessage("common.ok") + "</button>")
        var cancelBtn = $("<button class='hireDateCancelBtn'>" + messageResource.getMessage("common.cancel") + "</button>")
        footer.append(confirmBtn);
        footer.append(cancelBtn);
        warningDiv.append(footer);

        confirmBtn.click(_.bind(HireDateWarningDlg.prototype.close, this, true));
        cancelBtn.click(_.bind(HireDateWarningDlg.prototype.close, this, false));
    }

    _keydownHandler(event) {
        switch (event.keyCode) {
            case KEY_CODE_ESC:
                this.close(false);
                break;
            case KEY_CODE_ENTER:
                this.close(true);
                break;
        }
        cancelBubble(event);
        return false;
    }
};


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/HireDateWarning.js